import { createContext, useContext, useEffect } from 'react';

/**
 * A screen that is a workspace rather than a page to read — the page editor, with its live
 * preview beside the text — needs the whole window. It asks the shell for it with
 * `useWideWorkspace()`: the content loses its reading-width cap, and the sidebar folds into
 * the Menu drawer until the window is wide enough to keep both (2xl, 1536 px). A 1366 px
 * laptop then gives the editor and the preview the full width instead of 1,120 px of it.
 * A record editor asks only while it has a page to preview (`enabled`).
 */
export const WorkspaceContext = createContext<(wide: boolean) => void>(() => {});

export function useWideWorkspace(enabled = true) {
  const setWide = useContext(WorkspaceContext);
  useEffect(() => {
    if (!enabled) return;
    setWide(true);
    return () => setWide(false);
  }, [setWide, enabled]);
}
